import React, { useState, useMemo, useCallback, useEffect} from "react";
import { FaTrophy, FaGamepad, FaChartLine, FaListOl, FaHome, FaBars, FaUsers, FaScroll, FaCog, FaNewspaper } from "react-icons/fa";
import axios from "axios";
import logo from "../img/COBRADOR_LEAGUE_LOGO_02_FINAL.png"

/*const apiUrl = "http://localhost:5000/api_local"; /*LOCAL*/
const apiUrl = "https://elcobradorleague.com/api"; /*SERVER*/

const LeagueDashboard = () => {
 // const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [selectedMatch, setSelectedMatch] = useState(null);
  //const [player, setPlayers] = useState([]);
  const [match, setMatches] = useState([]);
  //const [matchinfo, setMatchInfo] = useState([]);
  const [matchInfo, setMatchInfo] = useState(null);
 
  const fetchMatches = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api.php?action=getmatches`); 
      setMatches(response.data);
    } catch (error) {
      console.error("Error fetching matches:", error);
    }
  };

  const handleMatchClick = async (match) => {
  setSelectedMatch(match);
  try {
    const response = await axios.get(`${apiUrl}/api.php?action=getmatchinfo&matchId=${match.id}`        
    );
    setMatchInfo(response.data);    
  } catch (error) {
    console.error("Error fetching matches:", error);
  }
  };

useEffect(() => {
  fetchMatches();
  //handleMatchClick(match);
}, []);
   
  const menuItems = [
    { name: "WH40k League", icon: FaHome, link: "/wh40k" },
    { name: "AOS League", icon: FaHome, link: "/" },
    { name: "Leaderboard", icon: FaTrophy, link: "/leaderboard1" },
    { name: "Matches", icon: FaGamepad, link: "/matches" },
    { name: "Players", icon: FaUsers },
    { name: "Rules", icon: FaScroll },
    { name: "Settings", icon: FaCog },
  ];

  const quickLinks = [
    { name: "Tournament Schedule", icon: FaGamepad },
    { name: "Army Lists", icon: FaScroll },
    { name: "Community Forum", icon: FaUsers },
    { name: "News & Updates", icon: FaNewspaper },
  ];

 /* const winRate = selectedPlayer && selectedPlayer.played > 0 
  ? (selectedPlayer.won / selectedPlayer.played) * 100 
  : 0;*/

  const [menuOpen, setMenuOpen] = useState(false);
  
  return (
    <div className="flex flex-col min-h-screen bg-gray-900 text-white">
      {/* Header */}
      <header className="bg-gray-800 p-4 shadow-lg">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="El Cobrador League Logo" className="w-10 h-10 rounded-full" />
            <h1 className="text-2xl font-bold">El Cobrador League - Warhammer 40k</h1>
          </div>

          {/* Botón Menú Móvil */}
          <button onClick={() => setMenuOpen(!menuOpen)} className="lg:hidden text-white">
          <FaBars size={24} />
          </button>

          <nav className={`lg:flex space-x-4 ${menuOpen ? "block" : "hidden"}`}>
            {menuItems.map((item, index) => (
              <a key={index} href={item.link} className="flex items-center space-x-1 text-gray-300 hover:text-white transition duration-200">
                <item.icon className="text-sm" />
                <span>{item.name}</span>
              </a>
            ))}
          </nav>
        </div>
      </header>

      {/* Full-width image */}
      <div className="w-full">
        <center><img src="https://c4.wallpaperflare.com/wallpaper/80/896/840/warhammer-40k-4k-popular-wallpaper-thumb.jpg"
          alt="El Cobrador League Banner"
          className="w-full h-80 object-cover"
        /></center>
      </div>

      {/* Main Content */}
      <div className="flex-grow p-8">

       {/* MATCHES */}
        <h1 className="text-4xl font-bold mb-8 text-center">Matches</h1>
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 items-stretch">
            <div className="lg:col-span-2 h-full">
                <div className="bg-gray-800 rounded-lg shadow-lg p-6">
                    <h2 className="text-2xl font-semibold mb-4">Matches Statistics</h2>
                    <div className="overflow-x-auto">
                        <table className="w-full table-auto">
                            <thead>
                                <tr className="bg-gray-700">
                                <th className="px-4 py-2 text-center">Date</th>
                                <th className="px-4 py-2 text-right">Player 1</th>
                                <th className="px-4 py-2 text-center">Score P1</th>
                                <th className="px-4 py-2 text-center"></th>
                                <th className="px-4 py-2 text-center">Score P2</th>
                                <th className="px-4 py-2 text-left">Player 2</th>
                                </tr>
                            </thead>
                            <tbody>
                                {match.map((match, index) => (
                                <tr
                                    key={match.id}
                                    className="hover:bg-gray-700 transition-colors duration-200 cursor-pointer"
                                    onClick={() => handleMatchClick(match)}                                
                                >
                                    <td className="px-4 py-2 text-center">{new Date(match.date).toLocaleDateString("es-ES")}</td>
                                    <td className="px-4 py-2 text-right">{match.nick1} <p className="text-gray-500 ">{match.army_p1}</p></td>
                                    <td className={match.score_p1 > match.score_p2 ? "text-green-500 px-4 py-2 text-center" : "text-red-500 px-4 py-2 text-center"}>{match.score_p1}</td>
                                    <td className="px-4 py-2 text-gray-500"> vs </td>
                                    <td className={match.score_p1 < match.score_p2 ? "text-green-500 px-4 py-2 text-center" : "text-red-500 px-4 py-2 text-center"}>{match.score_p2}</td>
                                    <td className="px-4 py-2 text-left">{match.nick2} <p className="text-gray-500 ">{match.army_p2}</p></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        
            <div className="lg:col-span-2 h-full">
                <div className="bg-gray-800 rounded-lg shadow-lg p-6 h-full overflow-y-auto">
                    <h2 className="text-2xl font-semibold mb-4">Player Matches</h2>
                    {selectedMatch ? ( 
                        <div className="rounded-lg bg-gray-800 p-2 shadow-lg">                 
                            <div className="space-y-2 max-h-[600px] overflow-y-auto">
                                {Object.keys(selectedMatch).length > 0 ? (                       
                                    <div className="flex items-center justify-between rounded-lg bg-gray-700 p-2">
                                        <div className="flex items-center justify-center rounded-lg bg-gray-700 w-full space-x-4">
                                            <div className="text-right basis-1/3"> 
                                                <p className="text-lg font-semibold"> {selectedMatch.nick1}</p>
                                                <p className="text-gray-400 font-semibold">{selectedMatch.army_p1}</p>
                                                <br/>
                                                <p className={match.score_p1 > match.score_p2 ? "text-green-500 text-right text-xl font-semibold" : "text-red-500 text-right text-xl font-semibold"}>{selectedMatch.score_p1}</p>
                                                <br/>
                                                <p >{selectedMatch.primary_p1}</p>
                                                <br/>
                                                <p>{selectedMatch.secondary_p1}</p>
                                                <br/>
                                                <p>{selectedMatch.battleready_p1}</p>
                                            </div>
                                            <div className="text-center text-gray-400 basis-1/3">          
                                                <br/>    
                                                vs<br/>    
                                                <br/>                                       
                                                <p>Total Score</p>
                                                <br/>
                                                <p>Primary Points</p>
                                                <br/>
                                                <p>Secondary Points</p>
                                                <br/>
                                                <p>BattleReady</p>
                                            </div>                                            
                                            <div className="text-left basis-1/3"> 
                                                <p className="text-lg font-semibold"> {selectedMatch.nick2}</p>
                                                <p className="text-gray-400 font-semibold">{selectedMatch.army_p2}</p>
                                                <br/>
                                                <p className={match.score_p1 > match.score_p2 ? "text-red-500 text-left text-xl font-semibold" : "text-green-500 text-left text-xl font-semibold"}>{selectedMatch.score_p2}</p>
                                                <br/>
                                                <p>{selectedMatch.primary_p2}</p>
                                                <br/>
                                                <p>{selectedMatch.secondary_p2}</p>
                                                <br/>
                                                <p>{selectedMatch.battleready_p2}</p>
                                            </div>
                                            
                                        </div>
                                    </div>
                               //
                                ) : (
                                <p className="text-gray-400">There are no matches for this player.</p>
                                )}
                            </div>
                        </div>
                    ) : (
                        <p className="text-gray-400">Click on a player to see their matches.</p>
                    )}
                </div>
            </div>    
        </div>

        <br></br>
        <br></br>            
      </div>

      {/* Quick Links */}
      <footer className="bg-gray-800 p-4">
        <div className="container mx-auto">
          <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {quickLinks.map((link, index) => (
              <a key={index} href="#" className="flex items-center space-x-2 text-gray-300 hover:text-white transition duration-200">
                <link.icon className="text-sm" />
                <span>{link.name}</span>
              </a>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LeagueDashboard;
